import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import ItemPhoto from '../../atoms/ItemPhoto';
import { resizeImage } from '../../../utils';
import DialogZoomedPhoto from '../../atoms/DialogZoomedPhoto';
;
/**
 *
 * @param  maxZoomWidth -  The size that the zoom dialog will cover the screen
 * @param resizeImageValue - This will be the width of the original non-zoomed image. Defaults to 800px
 */
const ImageWithZoom = ({ imageUrl = '', resizeImageValue = 800, hexCode, hexUrl, className = '', alt = '', isZoomable = true, onLoad, onError, fit, size = 'normal', maxZoomWidth = 'xl', width, height, maxHeight, minWidth, maxWidth, showWhenNoPhotoAvailable, unavailableText, clickImageToZoom, zoomIconSize, showFlag = true, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleZoomOpen = () => {
        setIsOpen(true);
    };
    const handleZoomClose = (event) => {
        event.stopPropagation();
        setIsOpen(false);
    };
    const shouldShowZoom = !(hexCode || hexUrl);
    return (_jsxs(_Fragment, { children: [_jsx(ItemPhoto, { imageUrl: resizeImage(imageUrl, resizeImageValue), hexCode: hexCode, hexUrl: hexUrl, className: className, alt: alt, isZoomable: isZoomable, onLoad: onLoad, onError: onError, fit: fit, onZoomClick: handleZoomOpen, size: size, width: width, height: height, minWidth: minWidth, maxWidth: maxWidth, maxHeight: maxHeight, showWhenNoPhotoAvailable: showWhenNoPhotoAvailable, unavailableText: unavailableText, clickImageToZoom: clickImageToZoom, showFlag: showFlag, zoomIconSize: zoomIconSize }), shouldShowZoom ? (_jsx(DialogZoomedPhoto, { imageUrl: imageUrl, alt: alt, isOpen: isOpen, handleZoomClose: handleZoomClose, maxZoomWidth: maxZoomWidth })) : null] }));
};
export default ImageWithZoom;
//# sourceMappingURL=index.js.map